import React from 'react';
import { FormattedMessage } from 'react-intl';
import instanceInitValues from '../../../../../constants/initialValues/instanceInitValues';
import SectionsBuilder from '../../../../../shared/template-builder/SectionsBuilder';

function InstanceData() {
  return (
    <SectionsBuilder
      key="instance"
      fieldArrayName="instance"
      paneId="instance"
      paneTitle={
        <FormattedMessage
          id="ui-plugin-inventory-templates.templateFields.instance.builder.paneTitle"
          defaultMessage="Instance Builder"
        />
      }
      initialValues={instanceInitValues}
    />
  );
}

export default InstanceData;
